import React, { useState } from "react";
import HRCalendarTable from "./components/HRCalendarTable";
import HRCalendarAddEditModal from "./components/HRCalendarAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';
import { ConfirmationModal } from "../../../../common/Modal";

const HRCalendarModule = ({
  user,
  data,
  loading,
  currentYearData,
  searchData,
  createHRCalendar,
  updateHRCalendar,
  deleteHRCalendar
}) => {
  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  // MODIFIED: Fixed the API data structure to match backend expectations
  const handleSave = async (form) => {
    // Convert form data to match backend DTO exactly
    const apiData = {
      year: Number(form.year),
      isActive: form.isActive,  // Send as boolean, not string
      isCurrentYear: form.isCurrentYear  // Send as boolean, not string
    };

    if (selectedItem) {
      const audit = [{
        setupArea: "HR Calendar",
        actionTaken: "update",
        field: "Year",
        newValue: apiData.year.toString(),
        oldValue: selectedItem.year.toString(),
        dateSaved: new Date(),
        savedById: user.id
      }];

      const res = await updateHRCalendar(selectedItem.id, apiData, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "HR Calendar",
        actionTaken: "insert",
        field: "Year",
        newValue: apiData.year.toString(),
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createHRCalendar(apiData, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  const handleDelete = (item) => {
    setItemToDelete(item);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (itemToDelete) {
      const res = await deleteHRCalendar(itemToDelete.id);
      if (res.success) {
        setShowDeleteConfirm(false);
        setItemToDelete(null);
      }
    }
  };

  return (
    <div className='p-4 space-y-4 relative'>
      {/* Current Year Indicator */}
      {currentYearData && (
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-700">
                Current active year: <strong>{currentYearData.year}</strong>
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
        <Button
          icon={<AddIcon />}
          name={"Add Calendar Year"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      <HRCalendarTable
        data={data}
        onEdit={handleEdit}
        onDelete={handleDelete}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        currentYearId={currentYearData?.id}
      />

      <HRCalendarAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
        existingData={data}
        currentYearData={currentYearData}
      />

      <ConfirmationModal
        visible={showDeleteConfirm}
        onClose={() => {
          setShowDeleteConfirm(false);
          setItemToDelete(null);
        }}
        onConfirm={confirmDelete}
        title="Delete Calendar Year"
        message={`Are you sure you want to delete year ${itemToDelete?.year}? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
      />
    </div>
  );
};

export default HRCalendarModule;